var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDuplicate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    enableBackground: "new 0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M23.578,6.23l-4.701-5.07c-0.171-0.184-0.409-0.288-0.66-0.288H9.624c-0.958,0-1.737,0.779-1.737,1.737v3.05 H3.918c-0.958,0-1.737,0.779-1.737,1.736v15.998c0,0.957,0.779,1.736,1.737,1.736h12.459c0.957,0,1.736-0.779,1.736-1.736v-3.049 h3.969c0.957,0,1.736-0.78,1.736-1.738V6.842C23.818,6.615,23.732,6.396,23.578,6.23z M18.934,3.868l1.851,1.996h-1.851V3.868z  M3.981,23.393L3.918,7.458h7.51v4.092c0,0.497,0.403,0.9,0.9,0.9h3.984v10.878L3.981,23.393z M13.228,8.655l1.85,1.996h-1.85V8.655 z M18.113,18.543v-6.914c0-0.227-0.086-0.445-0.24-0.612l-4.701-5.07c-0.17-0.184-0.41-0.288-0.66-0.288H9.685L9.624,2.671h7.509 v4.092c0,0.497,0.403,0.9,0.9,0.9h3.989l0.06,10.879H18.113z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuplicate);
export default __webpack_public_path__ + "static/media/icon-duplicate.ce508806.svg";
export { ForwardRef as ReactComponent };